import React from 'react';
import ChangeTable from './ChangeTable';

const EntraDocs = () => {
  return (
    <ChangeTable
      title="Recent Entra ID Documentation Changes"
      dataSource="entra-changes.json"
      showGuideLink={false}
    />
  );
};

export default EntraDocs;